import { Button } from '@getinapp/appetizer';
import * as S from './styles';
import { useConfirmEmailHook } from './hooks';

export const ConfirmEmail = () => {
  const {
    t,
    session,
    isConfirmEmailOpen,
    handleClickBackButton,
    handleValidateEmail,
    handleIsOpenConfirmEmailModal,
  } = useConfirmEmailHook();

  return (
    <S.Modal
      width="15%"
      title={<S.Title>{t('@ConfirmEmail.email-already-registered')}</S.Title>}
      isOpen={isConfirmEmailOpen}
      onRequestClose={() => handleIsOpenConfirmEmailModal(false)}
    >
      <S.Paragraph>{t('@ConfirmEmail.this-your-email')}</S.Paragraph>
      <S.Email>{session?.email}</S.Email>
      <S.Paragraph>{t('@ConfirmEmail.for-your-security')}</S.Paragraph>

      <S.ButtonGroup>
        <Button variant="outline" onClick={() => handleClickBackButton(true)}>
          {t('@ConfirmEmail.change-email')}
        </Button>
        <Button variant="primary" onClick={handleValidateEmail}>
          {t('@ConfirmEmail.validade-email')}
        </Button>
      </S.ButtonGroup>

      <S.BackButton onClick={() => handleClickBackButton(false)}>
        <span>{'<-'}</span>
        {t('@ConfirmEmail.back')}
      </S.BackButton>
    </S.Modal>
  );
};
